export default {
  // Navbar
  nav_home: 'Início',
  nav_shopping_guide: 'Guia de Compras',
  nav_spreadsheet: 'Spreadsheet',
  nav_finds: 'Finds',
  nav_categories: 'Categorias',
  nav_guides: 'Guias',
  nav_shipping: 'Envio',
  nav_qc: 'QC',
  nav_reviews: 'Avaliações',
  nav_safety: 'Segurança',
  nav_explore: 'Explorar Spreadsheet',

  // Hero
  hero_h1: 'CSSBuy Spreadsheet: Encontre Produtos, Compare Opções e Compre com Mais Segurança',
  hero_subtitle: 'Encontre produtos, links, listas, guias de compra, informações de QC, custos de envio e dicas de segurança em um único recurso independente sobre CSSBuy Spreadsheet.',
  hero_cta_primary: 'Explorar CSSBuy Spreadsheet',
  hero_cta_secondary: 'Ver Produtos e Finds',
  hero_trust_1: 'Recurso independente',
  hero_trust_2: 'Guias atualizados',
  hero_trust_3: 'Pesquisa de produtos',
  hero_trust_4: 'Dicas de segurança',
  hero_search_placeholder: 'Pesquise produtos, categorias, vendedores ou palavras-chave...',
  hero_search_button: 'Pesquisar',

  // What is section
  whatis_h2: 'O que é um CSSBuy Spreadsheet?',
  whatis_copy: 'Um CSSBuy Spreadsheet é uma forma prática de organizar produtos, links, categorias, vendedores e informações úteis para pesquisa antes de uma compra. Nosso objetivo é reunir informações relevantes em uma estrutura simples para ajudar você a comparar opções, entender o processo e tomar decisões mais informadas.',

  // Categories
  categories_h2: 'Explore Categorias Populares',
  categories_cta: 'Ver Todas as Categorias',
  cat_shoes: 'Tênis',
  cat_hoodies: 'Moletons',
  cat_tshirts: 'Camisetas',
  cat_jackets: 'Jaquetas',
  cat_pants: 'Calças',
  cat_bags: 'Bolsas',
  cat_accessories: 'Acessórios',
  cat_sportswear: 'Sportswear',
  cat_streetwear: 'Streetwear',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear',
  cat_jersey: 'Jersey',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',

  // Finds
  finds_h2: 'Últimos CSSBuy Finds',
  finds_sub: 'Descubra produtos e recursos populares organizados para facilitar sua pesquisa.',
  finds_table_product: 'Produto',
  finds_table_category: 'Categoria',
  finds_table_source: 'Fonte',
  finds_table_info: 'Informação',
  finds_table_updated: 'Atualizado',
  finds_table_view: 'Ver',
  finds_cta: 'Explorar Todos os Finds',

  // Guides
  guides_h2: 'Guias CSSBuy Mais Procurados',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_qc: 'CSSBuy QC',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_coupon: 'CSSBuy Coupon',
  guide_discount: 'CSSBuy Discount Code',

  // Comparison
  comparison_h2: 'Compare CSSBuy com Outras Plataformas',

  // Safety
  safety_h2: 'CSSBuy Safety Center',
  safety_copy: 'Aprenda a verificar links, analisar vendedores, entender fotos de QC, proteger seus dados, reconhecer páginas falsas e avaliar possíveis riscos antes de realizar um pedido.',
  safety_cta: 'Visitar Safety Center',

  // Final CTA
  final_cta_h2: 'Pronto para encontrar seu próximo CSSBuy Spreadsheet?',
  final_cta_primary: 'Explorar CSSBuy Spreadsheet',
  final_cta_secondary: 'Visitar o Site Principal',

  // Disclaimer
  disclaimer: 'Este é um recurso informativo independente e não é afiliado ao CSSBuy. Sempre verifique preços, custos de envio, políticas, vendedores e informações atuais na plataforma oficial antes de realizar uma compra.',

  // Footer
  footer_resources: 'Recursos',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_finds: 'Finds',
  footer_categories: 'Categorias',
  footer_guides: 'Guias',
  footer_shipping: 'Shipping',
  footer_qc: 'QC',
  footer_reviews: 'Reviews',
  footer_comparisons: 'Comparisons',
  footer_safety: 'Safety',
  footer_company: 'Empresa',
  footer_about: 'Sobre',
  footer_contact: 'Contato',
  footer_privacy: 'Política de Privacidade',
  footer_terms: 'Termos de Uso',
  footer_disclaimer: 'Disclaimer',
  footer_editorial: 'Editorial Policy',
  footer_language: 'Idioma',
  footer_lang_pt: 'Português',
  footer_lang_de: 'Deutsch',
  footer_lang_en: 'English',
  footer_copyright: '© 2026 CSSBuy Spreadsheet Resource. Recurso independente.',
  footer_main_site: 'Site Principal',

  // Article page
  article_breadcrumb_home: 'Início',
  article_breadcrumb_guides: 'Guias',
  article_reading_time: 'min de leitura',
  article_author: 'Redação CSSBuy Spreadsheet',
  article_published: 'Publicado',
  article_updated: 'Atualizado',
  article_toc: 'Conteúdo',
  article_faq: 'Perguntas Frequentes',
  article_related: 'Leia Também',
  article_cta: 'Explore Mais no CSSBuy Spreadsheet',
  article_back_to_home: 'Voltar ao Início',

  // 404
  notfound_title: 'Página Não Encontrada',
  notfound_desc: 'A página que você procura não existe. Volte para a página inicial e continue explorando.',
  notfound_back: 'Voltar ao Início',

  // Meta
  meta_title_home: 'CSSBuy Spreadsheet 2026: Finds, Links & Complete Guide | Recurso Independente',
  meta_desc_home: 'Recurso independente sobre CSSBuy Spreadsheet. Encontre produtos, guias de compra, custos de envio, QC, cupons e dicas de segurança.',
  meta_title_article: 'CSSBuy Spreadsheet Complete Guide 2026: Como Usar, Encontrar Produtos e Comprar com Segurança',
  meta_desc_article: 'Guia completo e independente sobre CSSBuy Spreadsheet. Aprenda como organizar produtos, verificar links, pesquisar vendedores e tomar decisões de compra mais seguras.',

  // Buttons to main site
  btn_main_site: 'CSSBuy Spreadsheet',
  btn_buy_now: 'Buy It Now',
  btn_visit_main: 'Visitar Site Principal',

  // Category dropdown
  dropdown_label: 'Categorias',
  dropdown_all: 'Todas as Categorias',

  // Misc
  loading: 'Carregando...',
  search: 'Pesquisar',
  close: 'Fechar',
  read_more: 'Ler mais',
  view_all: 'Ver todos',
  updated: 'Atualizado',
  independent_resource: 'Recurso Independente',
};